<template>
  <div
    v-if="searchType === 'etablissement'"
    class="inter-level2">
    <SearchEstablishments
      :display-kind="establishmentDisplayKind"
      :is-logged-in="isLoggedIn" />
  </div>
  <div
    v-if="searchType === 'metiers'"
    class="inter-level2">
    <SearchMetiers :is-logged-in="isLoggedIn" />
  </div>
  <div
    v-if="searchType === 'nos-conseils'"
    class="inter-level2">
    <SearchArticles :is-logged-in="isLoggedIn" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import type { EstablishmentSearchDisplayKind } from '~/types/EstablishmentSearch'

const route = useRoute()

const pathSegments: ComputedRef<string[]> = computed(() => {
  const p: string | string[] | undefined = route.params.slug
  return Array.isArray(p) ? p : p ? [p] : []
})

const establishmentDisplayKind: ComputedRef<EstablishmentSearchDisplayKind> = computed(
  (): EstablishmentSearchDisplayKind => {
    const raw = route.query.displayKind
    const value = Array.isArray(raw) ? raw[0] : raw
    return value === 'program' ? 'program' : 'school'
  },
)

const searchType: ComputedRef<string | undefined> = computed((): string | undefined => {
  const segs: string[] = pathSegments.value
  return segs[segs.length - 1]
})

const { isLoggedIn } = useAuth()
</script>
